// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VerticalSpacer-cls1__b7d86bcf5bf0c62f0069{/*!*/}.VerticalSpacer-cls2___1e3c4931c6297665a7f{display:block;clear:both;width:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "VerticalSpacer-cls1__b7d86bcf5bf0c62f0069",
	"cls2": "VerticalSpacer-cls2___1e3c4931c6297665a7f VerticalSpacer-cls1__b7d86bcf5bf0c62f0069"
};
export default ___CSS_LOADER_EXPORT___;
